import request from '../request'




export function sendTest(data) {
    return request({
        url: '/system/zhj/send',
        method: 'get',
        params: data
    })
}

export function getSerialPort(data) {
    return request({
        url: '/system/zhj/getSerialPort',
        method: 'get',
        params: data
    })
}

//获取设备树
export function getZhjDeviceLocation(data) {
    return request({
        //url:"http://127.0.0.1:8999/gisData/Cesium.js",
        url: '/device/zhjDeviceLocation',
        method: 'get',
        params: data
    })
}

//获取设备树
export function getZTreeGroupDevice(data) {
    return request({
        url: '/device/zTreeGroupDevice',
        method: 'get',
        params: data
    })
}


//获取卡位置信息
export function getlistDeviceLocation(data) {
    return request({
        url: '/device/listDeviceLocation',
        method: 'get',
        params: data
    })
}

//获取本机位置信息
export function getzhjDeviceLocation(data) {
    return request({
        url: '/device/zhjDeviceLocation',
        method: 'get',
        params: data
    })
}

//增删改查

//获取树形结构
export function iViewTreeDeviceGroup(data) {
    return request({
        url: '/deviceGroup/iViewTreeDeviceGroup?expand=true',
        method: 'get',
        params: data
    })
}

//获取菜单数据
export function getDeviceGroup(data) {
    return request({
        url: '/deviceGroup/getDeviceGroup',
        method: 'get',
        params: data
    })
}

//创建菜单
export function createDeviceGroup(data) {
    return request({
        url: '/deviceGroup/createDeviceGroup',
        method: 'post',
        data: data
    })
}

//修改菜单
export function updateDeviceGroup(data) {
    return request({
        url: '/deviceGroup/updateDeviceGroup',
        method: 'post',
        data: data
    })
}

//删除菜单
export function deleteDeviceGroup(data) {
    return request({
        url: '/deviceGroup/deleteDeviceGroup',
        method: 'post',
        data: data
    })
}

//列表管理
//device/pageDevice?page=1&pageSize=10

//北斗卡列表
export function pageDevice(data) {
    return request({
        url: '/device/pageDevice',
        method: 'get',
        params: data
    })
}

//查询分组列表
export function iViewCascadeDeviceGroup(data) {
    return request({
        url: '/deviceGroup/iViewCascadeDeviceGroup',
        method: 'get',
        params: data
    })
}

//保存卡
export function createDevice(data) {
    return request({
        url: '/device/createDevice',
        method: 'post',
        data: data
    })
}

//修改卡
export function updateDevice(data) {
    return request({
        url: '/device/updateDevice',
        method: 'post',
        data: data
    })
}

//删除卡
export function deleteDevice(data) {
    return request({
        url: '/device/deleteDevice',
        method: 'post',
        data: data
    })
}

//获取指挥卡信息
export function getListDirector(data) {
    return request({
        url: '/director/listDirector',
        method: 'get',
        data: data
    })
}


// cardNumber(卡号) createTime（创建时间） deviceGroup.name所属节点)